export const environment = {
	production: false,
	version: '1.7.18',
	firebase: {
		apiKey: "AIzaSyCnsZ7MIZnzyZI3uli3KCYfPNm1r-YcDHE",
		authDomain: "attaboy-dev.firebaseapp.com",
		databaseURL: "https://attaboy-dev.firebaseio.com",
		projectId: "attaboy-dev",
		storageBucket: "attaboy-dev.appspot.com",
		messagingSenderId: "551819506955"
	}
};

// export const environment = {
//	 production: false,
//	 version: '1.7.18',
//	 firebase: {
// 		apiKey: "AIzaSyC7n3Jj_s8VYnE4op9Tr195VBwOQ26oFWc",
// 		authDomain: "attaboy-161918.firebaseapp.com",
// 		databaseURL: "https://attaboy-161918.firebaseio.com",
// 		storageBucket: "attaboy-161918.appspot.com",
// 		storageURL: "https://attaboy-161918.appspot.com.storage.googleapis.com",
// 		messagingSenderId: "491029542802"
//	 }
// };



// WEBPACK FOOTER //
// /Users/axel/Sites/Bannerboy/Internal/attaboy-angular/src/environments/environment.ts